import { jsx as _jsx } from "react/jsx-runtime";
// sections/tabsAndSubpanelSection.tsx
import { borderSubpanelDefault } from "@/utils/funcs";
import { useThemeConfig } from "../themeConfigContext";
import { GridSection } from "./gridSection";
export default function TabsAndSubpanelSection(_a) {
    var _b = useThemeConfig(), t = _b.t, color = _b.color, colorsLigne = _b.colorsLigne;
    return (_jsx(GridSection, { rows: [
            [
                {
                    title: "Tabs",
                    label: t("LBL_TABS", { ns: "Administration" }) || "Tabs",
                    margin: true,
                    extraProps: {
                        spacingElement: true,
                        tabPosition: true,
                    },
                },
                {
                    title: "Tab hovered",
                    label: t("LBL_TAB_HOVER", { ns: "Administration" }) || "Hovered tab",
                    borderRadius: true,
                },
            ],
            [
                {
                    title: "Tab",
                    label: t("LBL_TAB", { ns: "Administration" }) || "Tab",
                    borderRadius: true,
                },
                {
                    title: "Tab selected",
                    label: t("LBL_TAB_SELECTED", { ns: "Administration" }) || "Tab selected",
                    borderRadius: true,
                    extraProps: {
                        borderColorTab: true,
                        borderWidth: true,
                        baseColor: color !== null && color !== void 0 ? color : undefined,
                        colorsLigne: colorsLigne,
                    },
                },
            ],
            [
                {
                    title: "sub_panel",
                    label: t("LBL_SUBPANEL", { ns: "Administration" }) || "Subpanel",
                    margin: true,
                    padding: true,
                    borderRadius: true,
                    extraProps: {
                        borderDefaultValue: borderSubpanelDefault,
                    },
                },
            ],
        ] }));
}
